export default __webpack_public_path__ + "static/media/caio-game-mobile.a43d43e3.png";